export default "__VITE_ASSET__NPolQRKA__"